/* eslint-disable */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const LOCAL_USER_QUERY = gql`
    query UserQuery {
        user @client {
            id
            email
            firstName
            lastName
            orgId
            orgName
            accountOwner
        }
    }
`;

export interface User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    orgId: string;
    orgName: string;
    accountOwner: boolean;
}

function useUser(): User | null {
    const { data: gqlState } = useQuery(LOCAL_USER_QUERY);
    return gqlState && gqlState.user ? gqlState.user : null;
}

export { useUser };
